<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5 class="pull-left" :style="{'color': hasError ? '#a94442' : 'inherit'}">
        <i class="fa fa-arrows-alt handle" style="cursor: grab;"></i>

        {{ headline }}
      </h5>

      <div class="btn-group pull-right" style="margin-top: 4px;">
        <button class="btn btn-white btn-sm" type="button" @click="collapsed = !collapsed">
          <i class="fa" :class="collapsed ? 'fa-plus' : 'fa-minus'"></i> {{ collapsed ? 'Show' : 'Hide' }}
        </button>

        <button class="btn btn-white btn-sm" type="button" @click="$emit('remove')">
          <i class="fa fa-minus"></i> Remove
        </button>
      </div>

      <div class="clearfix"/>
    </div>

    <div class="panel-body" v-if="!collapsed">
      <BodyCategoryParameterForm
          v-model="data.body_category_parameters"
          :body-category="value.body_category"
          :errors="errors"
          :company-id="companyId"
      />
    </div>
  </div>

</template>

<script>
import BodyCategoryParameterForm from "../BodyCategoryParameterForms/Base.vue";

export default {
  components: {BodyCategoryParameterForm},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    initialCollapsed: {
      required: false,
      default: false
    },

    companyId: {
      required: false,
    },
  },

  data() {
    return {
      collapsed: this.initialCollapsed
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    hasError() {
      return Object.keys(this.errors).length
    },

    headline() {
      return {
        'text': 'Text',
        'fact-box': 'Fact Box',
        'quote': 'Quote',
        'image': 'Image',
        'gallery': 'Gallery',
        'podcast': 'Podcast',
        'social-media': 'Social Media',
        'video': 'Video'
      }[this.value.body_category]
    }
  }
}
</script>